import { useContext, useEffect } from 'react'
import { Col } from 'react-bootstrap'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import Title from '../title/Title'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'

const CustomPanelGroup = (props) => {
  const designContext = useContext(DesignContext)
  const { isUiChanged, setIsUiChanged } = designContext
  let { uischema, schema, data, handleChange, path, renderers } = props
  const isRender = objectPath.get(isUiChanged, `${uischema.key}.isRender`)

  let { layoutDesign = 1 } = uischema

  const updateData = (newValue) => {
    let newData = { ...data, ...newValue }
    handleChange(path, newData)
  }

  useEffect(() => {
    if (isRender) {
      objectPath.del(isUiChanged, `${uischema.key}.isRender`)
      setIsUiChanged(isUiChanged)
    }
  }, [isRender])

  if (layoutDesign === 1) {
    return (
      <Col
        className="row w-100 mx-auto"
        sm={uischema.layoutWidth}
        style={{
          padding: uischema.layoutPadding ?? '',
          margin: uischema.layoutMargin ?? '',
          minWidth: uischema.minWidth,
          maxWidth: uischema.maxWidth,
        }}
      >
        {uischema.title && (
          <Col sm="12" className="px-0">
            <h5 className="px-3 w-100">
              <Title {...props} />
            </h5>
            <hr className="my-1" />
          </Col>
        )}
        {uischema.elements.map((element) => {
          return (
            <JsonForms
              schema={schema}
              uischema={element}
              config={{
                updateData: updateData,
                isArray: true,
                arrayName: element.name,
                arrayKey: element.key,
              }}
              data={data}
              renderers={renderers}
              cells={materialCells}
            />
          )
        })}
      </Col>
    )
  }

  return (
    <fieldset
      className="scheduler-border row"
      style={{
        padding: uischema.layoutPadding ?? '.5rem',
        margin: uischema.layoutMargin,
        minWidth: uischema.minWidth,
        maxWidth: uischema.maxWidth,
      }}
    >
      <legend
        className="scheduler-border"
        style={{
          fontSize: '16px',
        }}
      >
        <Title {...props} />
      </legend>
      <div className="w-100 row">
        {uischema.elements.map((element) => {
          return (
            <JsonForms
              schema={schema}
              uischema={element}
              config={{
                updateData: updateData,
                isArray: true,
                arrayName: element.name,
                arrayKey: element.key,
              }}
              data={data}
              renderers={renderers}
              cells={materialCells}
            />
          )
        })}
      </div>
    </fieldset>
  )
}

export default CustomPanelGroup
